import ActivityBodyCollapse from './ActivityBodyCollapse';

export default ActivityBodyCollapse;
